var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTkava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3514 24.2369C24.1279 24.262 23.9927 24.2895 23.8576 24.2895C22.8802 24.2895 21.9028 24.3045 20.9271 24.2803C20.7235 24.2689 20.5329 24.179 20.3967 24.0301C18.3909 21.4793 16.4021 18.9135 14.4031 16.3585C14.1804 16.0758 14.1838 15.8965 14.4107 15.608C16.3995 13.0805 18.3646 10.5338 20.3534 8.00637C20.5003 7.83256 20.7109 7.72235 20.9398 7.6995C21.9436 7.66781 22.9499 7.68282 23.9545 7.68616C24.0857 7.69928 24.2155 7.7227 24.3429 7.7562C24.2426 7.91464 24.1806 8.03138 24.1007 8.13478C22.1742 10.6409 20.2463 13.1447 18.317 15.6463C18.1181 15.9032 18.1206 16.0716 18.317 16.3293C20.2536 18.8259 22.1824 21.3275 24.1032 23.8342C24.1806 23.9409 24.2367 24.051 24.3514 24.2369Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7819 16.0065C12.7819 18.5898 12.7718 21.1681 12.7911 23.7489C12.7911 24.1772 12.6523 24.3072 12.2399 24.2931C11.5549 24.2681 10.8674 24.2756 10.1807 24.2847C9.88782 24.2847 9.75485 24.2081 9.7599 23.8839C9.7672 18.6256 9.7672 13.3668 9.7599 8.10745C9.7599 7.79662 9.88193 7.69079 10.1807 7.69079C10.8808 7.69829 11.5827 7.70912 12.2845 7.68079C12.7053 7.66412 12.7962 7.83662 12.7936 8.21995C12.7802 10.8149 12.7869 13.4099 12.7869 16.0048L12.7819 16.0065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkava);
export default __webpack_public_path__ + "static/media/tkava.4c4dae579abdfbbf2a585ee96c02af51.svg";
export { ForwardRef as ReactComponent };